import { mutationOptions, queryOptions } from '@tanstack/react-query'
import { OrganizationsListModel } from 'src/models/organizations.models'
import { QueryError } from 'src/queries/network.utils'
import {
  PutOutOfPocketExpensesFields,
  PutOutOfPocketExpensesResponse,
} from 'src/queries/organizations/outOfPocketExpenses/outOfPocketExpenses.models'
import {
  getOutOfPocketExpensesEnabled,
  putOutOfPocketExpensesSettings,
} from 'src/queries/organizations/outOfPocketExpenses/outOfPocketExpenses.network'
import { orgQueryKeys, queryCacheOptions } from 'src/queries/queries.constants'

export const orgOutOfPocketExpensesQueryKeys = {
  enabled: (orgId: string | undefined) =>
    [...orgQueryKeys.detail(orgId), 'outofpocketexpenses'] as const,
}

export const orgOutOfPocketExpensesQueries = {
  enabled: (orgId: string | undefined) =>
    queryOptions({
      queryKey: orgOutOfPocketExpensesQueryKeys.enabled(orgId),
      queryFn: async () => {
        const data = await getOutOfPocketExpensesEnabled(orgId!)
        return data.hasOutOfPocketExpenses
      },
      enabled: Boolean(orgId),
      ...queryCacheOptions(),
    }),
}

export type PutOutOfPocketExpensesParams = {
  orgId: string
  body: PutOutOfPocketExpensesFields
}

export const orgOutOfPocketExpensesMutations = {
  put: () =>
    mutationOptions<
      PutOutOfPocketExpensesResponse,
      QueryError,
      PutOutOfPocketExpensesParams
    >({
      mutationFn: (params) =>
        putOutOfPocketExpensesSettings(params.orgId, params.body),
    }),
}

export const isOutOfPocketExpensesVisible = (
  organization: OrganizationsListModel | undefined,
  enabled: boolean | undefined,
): boolean =>
  organization !== undefined
    ? Boolean(enabled) && organization.isOutOfPocketExpensesVisible
    : false
